// import logo from '../logo_square_transparent.png';
import '../App.css';
import * as React from 'react';
import CountUp from 'react-countup';
import { businesses } from '../data/businesses';
import { stats, mainPageText } from "../data/general"
import Rellax from 'rellax';
import { useEffect, useRef } from 'react';
import Footer from './Footer/Footer';
import MyCalendar from './Calendar/CalendarModule';
import Background from './Background/Background';
import Mission from './Mission/Mission';
import Intro from './Intro/Intro';
import FeaturedBusiness from './FeaturedBusiness/FeaturedBusiness';
import Mynavbar from './mynavbar'
import UserListView from './Admin/UserListView';
import StatisticsView from './Admin/Statistics';
import GenReferral from './Admin/GenReferral';
import EventApproveList from './Admin/EventApproveList';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Stack } from '@mui/material';
import log from '../images/TCL_logoFullColor1.png'
import AdminSetting from './Admin/AdminSettings'

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function MainPage() {
    const token = localStorage.getItem("calendar_admin");
    const user_Id = localStorage.getItem("userId");
    const isadmin = localStorage.getItem('admin_user');
    const [value, setValue] = React.useState(0);

    const rellaxRef = useRef();



    useEffect(() => {
        // Redirect if 'admin_user' is null
        // console.log('------', isadmin);
        // if ( isadmin == 'true') {
        //     window.location.href = '/admin';
        // } else {
        //     window.location.href = '/';
        // }

        // Initialize Rellax for scroll effects
        new Rellax(".rellax", {
            speed: -10,
            center: false,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
        });

        new Rellax(rellaxRef.current, {
            speed: -10,
            center: false,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
        });
    }, []); // Adding isadmin to the dependency array


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (
        <div className="App">
            <Mynavbar />
            <Background />
            {isadmin == 'true' ?
                (
                    <>
                        <StatisticsView />
                        <Box sx={{ zIndex: 1, width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: { xs: 600, sm: '100%' } }}>
                                <Tabs value={value}
                                    onChange={handleChange}
                                    aria-label="basic tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    sx={{
                                        '& .MuiTabs-scroller': {
                                            overflowX: 'auto', // Enable horizontal scrolling on mobile
                                        },
                                    }}>
                                    <Tab label="Approving Event List" {...a11yProps(0)} />
                                    <Tab label="Referral" {...a11yProps(1)} />
                                    <Tab label="Admin Calendar" {...a11yProps(2)} />.
                                    <Tab label="Settings" {...a11yProps(3)} />
                                </Tabs>
                            </Box>
                            <CustomTabPanel value={value} index={0}>
                                <EventApproveList />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                                <GenReferral />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={2}>
                                <MyCalendar />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={3}>
                                <AdminSetting />
                            </CustomTabPanel>
                        </Box>

                    </>

                ) :
                <Stack sx={{ height: '100vh' }}>
                    <div className="App-header foreground">
                        <img src={log} className="App-logo" alt="logo" />
                    </div>
                </Stack>
            }
            <Footer />
        </div>
    );
}

export default MainPage;